exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action[data-v-06c8e6c4] {\n  position: relative;\n  overflow: hidden;\n}\n.action[data-v-06c8e6c4]:has(input:disabled) {\n  opacity: .5;\n  cursor: not-allowed;\n}\n.progress[data-v-06c8e6c4] {\n  position: absolute;\n  background-color: #95e7f3;\n  transition: width .3s ease-in-out;\n  left: 0;\n  top: 0;\n  height: 100%;\n}\n", ""]);

// exports
